import { render, staticRenderFns } from "./ChooseEvent.vue?vue&type=template&id=4aaff8e9&lang=pug&"
import script from "./ChooseEvent.vue?vue&type=script&lang=js&"
export * from "./ChooseEvent.vue?vue&type=script&lang=js&"
import style0 from "./ChooseEvent.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports